import React, { Fragment } from 'react';
import {
  List,
  Edit,
  Create,
  Datagrid,
  TextField,
  BooleanField,
  BooleanInput,
  EditButton,
  DisabledInput,
  SimpleForm,
  ImageField,
  ImageInput,
  TextInput,
  SelectInput,
  CardActions,
  ListButton,
} from 'react-admin';
import CheckBox from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlank from '@material-ui/icons/CheckBoxOutlineBlank';

import BulkUpdateButton from './ui/BulkUpdateButton';
import BulkDeleteButton from './ui/BulkDeleteButton';
import ArrayChipField from './ui/ArrayChipField';
import ListFilter from './ui/ListFilter';

const types = [
  { id: 'politician', name: 'Politician' },
  { id: 'celebrity', name: 'Celebrity' },
  { id: 'event', name: 'Event' },
];

const TopicBulkActionButtons = props => (
  <Fragment>
      <BulkUpdateButton {...props} field='active' value={true} label='Activate' icon={<CheckBox />} color='primary' />
      <BulkUpdateButton {...props} field='active' value={false} label='Deactivate' icon={<CheckBoxOutlineBlank />} color='secondary' />
      <BulkDeleteButton {...props} />
  </Fragment>
);

const TopicEditActions = ({ basePath, data, resource }) => (
  <CardActions>
      <ListButton basePath={basePath} variant="outlined" style={{marginRight: '10px', padding: '7px 16px'}} />
  </CardActions>
);

export const TopicList = props => (
  <List title="Topics" {...props} bulkActionButtons={<TopicBulkActionButtons />} filters={<ListFilter />}>
    <Datagrid>
      <ImageField source="thumbnail" sortable={false} />
      <TextField source="name" />
      <TextField source="topic_type" />
      <ArrayChipField source="keywords" sortable={false} />
      <BooleanField source="active" />
      <EditButton label="" />
    </Datagrid>
  </List>
);

const SiteName = ({ record }) => {
  return <span>Topic {record ? `"${record.name}"` : ''}</span>;
};

export const TopicEdit = props => (
  <Edit title={<SiteName />} actions={<TopicEditActions />} {...props}>
    <SimpleForm>
      <DisabledInput source="id" />
      <SelectInput source="topic_type" choices={types} />
      <TextInput source="name" />
      <ImageInput source="thumbnail" label="Image" accept="image/*">
        <ImageField source="src" title="name" />
      </ImageInput>
      <TextInput source="keywords" />
      <TextInput source="tags" />
      <BooleanInput source="active" />
    </SimpleForm>
  </Edit>
);

const required = (message = 'Required') =>
    value => value ? undefined : message;

export const TopicCreate = props => (
  <Create title="Create Topic" actions={<TopicEditActions />} {...props}>
    <SimpleForm>
      <TextInput label="Title" validate={required()} source="name" />
      <ImageInput source="thumbnail" label="Image" accept="image/*">
        <ImageField source="thumbnail" title="name" />
      </ImageInput>
      <TextInput source="keywords" validate={required()} />
      <SelectInput source="topic_type" choices={types} />
      <TextInput source="tags" />
    </SimpleForm>
  </Create>
);



// WEBPACK FOOTER //
// ./src/resources/topics.js